/**
 * Les signets de l'utilisateur (`/api/user/prefs`) → `{ favorites, labels }`.
 *
 * Un favori est une URL du front ; son libellé est rangé à part, dans une carte
 * url → nom. Deux clés côté serveur (`favorites`, `favorite_labels`), une seule
 * forme côté page — TOUJOURS les deux clés, même vides, pour qu'un `InList` ou
 * un `toggleData` n'aient jamais à composer avec `undefined`.
 *
 * Les clés gardent leurs noms SERVEUR (`favorite_labels`, pas `favoriteLabels`) :
 * l'enregistrement est un `data: { prefs: ~~.favs }`, un seul niveau — le seul
 * que `submitData` évalue — donc le magasin de la page EST le corps du POST.
 *
 * Justification config-first : le GET (`{prefs:{…}}`) et le POST de sauvegarde
 * (`{ok, prefs:{…}}`) doivent converger vers CETTE forme, faute de quoi le
 * premier enregistrement remplacerait la liste par l'enveloppe du serveur. Deux
 * réponses de formes différentes réduites à une seule : ni `additionalDataSource`
 * ni `Switch` ne savent le faire.
 */
export const userFavoritesProcessor = ({ requestContext, responseContext, dataToProcess }) => {
  if (!requestContext?.url?.includes('/api/user/prefs')) return dataToProcess;
  if (responseContext?.status >= 400) return dataToProcess;
  const prefs = dataToProcess?.prefs;
  const favorites = prefs?.favorites;
  const labels = prefs?.favorite_labels;
  return {
    favorites: Array.isArray(favorites) ? favorites.filter((u) => typeof u === 'string' && u) : [],
    favorite_labels: labels && typeof labels === 'object' && !Array.isArray(labels) ? labels : {},
  };
};
